import React, { useEffect } from "react";
import {
  Box,
  Button,
  ClickAwayListener,
  Paper,
  MenuList,
  MenuItem,
  Popper,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Colors } from "../../utils/constants";
import {
  updateAbdcGrade,
  updateSJRGrade,
} from "../../store/slice/browseFilterSlice";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../store/hooks";
const data = [
  { label: "All", value: "" },
  { label: "Q1", value: "Q1" },
  { label: "Q2", value: "Q2" },
  { label: "Q3", value: "Q3" },
  { label: "Q4", value: "Q4" },
];

interface SJRGradeItem {
  label: string;
  value: string;
}

interface SJRGradeDropdownProps {
  handleSJRGrade: (grade: SJRGradeItem) => void;
  from?: string;
}

const SJRGradeDropdown: React.FC<SJRGradeDropdownProps> = ({
  handleSJRGrade,
  from,
}) => {
  const basicSearchSJRGrade: string = useAppSelector(
    (state) => state.filterReducer?.sjrGrade
  );

  const journalFinderSJRGrade: string = useAppSelector(
    (state) => state.browseFilterSlice?.sjrGrade
  );

  let initialItem;

  if (from === "basicSearch") {
    initialItem = data.find((d) => d.value === basicSearchSJRGrade) || data[0];
  } else if (from === "journalFinder") {
    initialItem =
      data.find((d) => d.value === journalFinderSJRGrade) || data[0];
  } else {
    initialItem = data[0];
  }

  // Find the initial matching object
  // const initialItem =
  //   data.find((d) => d.value === basicSearchSJRGrade) || data[0];
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [open, setOpen] = React.useState(false);
  // const [selectedItem, setSelectedItem] = React.useState(sjrGrade);
  const [selectedItem, setSelectedItem] =
    React.useState<SJRGradeItem>(initialItem);
  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(updateSJRGrade(selectedItem.value));
    handleSJRGrade(selectedItem);
  }, [selectedItem]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen((prev) => !prev);
  };

  const handleSelect = (item: { label: string; value: string }) => {
    setSelectedItem(item);
    setOpen(false);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ position: "relative", display: "inline-block" }}>
      <Button
        style={{
          textAlign: "left",
          color: Colors.black,
          paddingTop: 0,
          paddingBottom: 0,
        }}
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="outlined"
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        <Button
          sx={{
            fontSize: "0.8rem",
            color: Colors.black,
            // minHeight: 0,
            // padding: "5px 5px",

            fontFamily: "Helvetica Neue",
            fontStyle: "normal",
            fontWeight: 400,
            // fontSize: { xs: 12, sm: 14, md: 14 },
            display: "flex",
            alignItems: "center",
          }}
        >
          SJR Quartile {selectedItem.label}
        </Button>
      </Button>

      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        modifiers={[
          {
            name: "offset",
            options: {
              offset: [0, 4],
            },
          },
          {
            name: "preventOverflow",
            options: {
              boundary: "viewport",
            },
          },
        ]}
      >
        <ClickAwayListener onClickAway={handleClickAway}>
          <Paper sx={{ maxHeight: 300, overflowY: "auto" }}>
            <MenuList>
              {data.map((item) => (
                <MenuItem
                  key={item.value}
                  selected={item.value === selectedItem.value}
                  onClick={() => handleSelect(item)}
                >
                  {item.label}
                </MenuItem>
              ))}
            </MenuList>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
};

export default SJRGradeDropdown;
